<div class="row align-middle">
  <div *ngIf="!this.labelHidden" class="col-sm-4">{{this.label}}</div>
  <div class="col-sm-3"><button class="btn btn-primary" (click)="this.upload()" i18n>Seleccionar fitxer</button></div>
  <div class="col-sm-5" [hidden]="this.size == 0">{{this.name}} ({{this.size | size }})</div>
  <input type="file" class="form-control-file" (change)="this.onFileChange($event)" #uploadFileInput hidden style="width: 0px"/>
</div>
